<template>
    <div>

        <section class="header-web">
            <div class="back-shadow"></div>
            <div class="container-fluid">
                <div class="row flex-set">
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="header-txt">
                            <h1>Webinars</h1>
                            <h2>Introducing <span class="ornge">EmpowerYouth Masterclass - A Webinar Series</span>
                                Created To Help You Understand And Immerse Yourself In The Latest Career Options.</h2>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="header-img">
                            <img src="https://empoweryouth.com/assets/themes/ey/images/pages/webinar/web.png"/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="upcoming-web" v-if="webinarsList.length">
            <div class="container">
                <div class="row">
                    <div class="heading-style">Upcoming Webinars</div>
                </div>
                <div class="row">
                    <div class="col-md-4 col-sm-6" v-for="wl in webinarsList">
                        <div class="web-card">
                            <div class="web-img">
                                <router-link :to="{path: '/webinar-detail?id=' + wl.webinar_enc_id}">
                                    <img :src="wl.image ? wl.image : '/images/mentorship/default-cover.png'">
                                </router-link>
                                <div class="web-detail-date">
                                    <div class="web-date"
                                         v-html="getDate(wl.webinarEvents[0].start_datetime) +' '+ getMonth(wl.webinarEvents[0].start_datetime)"></div>
                                    <div class="web-paid" v-if="!wl.price || wl.price === '0'">
                                        Free
                                    </div>
                                    <div class="web-paid" v-else>
                                        <i class="fas fa-rupee-sign"></i> {{ wl.price }}
                                    </div>
                                </div>
                            </div>
                            <div class="web-inr">
                                <div class="web-title">
                                    <router-link :to="{path: '/webinar-detail?id=' + wl.webinar_enc_id}">
                                        {{ wl.title }}
                                    </router-link>
                                </div>
                                <div class="web-speaker">
                                    <span>
                                        {{ wl.speakers }}
                                    </span>
                                </div>
                                <div class="web-des" v-html="wl.description"></div>
                            </div>
                            <div class="reg-btn-count">
                                <div class="register-count">
                                    <div class="reg-img" v-if="wl.webinarRegistrations">
                                        <span class="reg" v-for="(av, index) in wl.webinarRegistrations"
                                              v-if="wl.webinarRegistrations.length">
                                            <img :src="av.image"/>
                                        </span>
                                    </div>
                                    <span class="cont"> {{ wl.count }} Registered</span>
                                </div>
                                <div class="register-btns" v-if="userType === 'Individual'">
                                    <button type="button" v-on:click="registerWebinar($event)"
                                            :data-key="wl.webinar_enc_id" v-if="!wl.is_registered" class="btn-drib">
                                        <i class="icon-drib fa fa-arrow-right"></i> Register Now
                                    </button>
                                    <button type="button" class="btn-drib disabled" v-else>Registered</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="upcoming-web how-it-works">
            <div class="container">
                <div class="row">
                    <div class="heading-style">How To Join A Webinar</div>
                </div>
                <div class="row">
                    <div class="col-md-4 col-sm-4">
                        <div class="step">
                            <div class="step-img">
                                <img
                                    src="https://empoweryouth.com/assets/themes/ey/images/pages/webinar/icons-registration.png"/>
                            </div>
                            <div class="step-text">
                                <h3>1. Register</h3>
                                <p>Register for the webinar by simply filling all the required details and clicking on
                                    the
                                    "Request For a Webinar' button. Once registered, a mail will the join link will be
                                    sent to
                                    you.</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-4">
                        <div class="step">
                            <div class="step-img">
                                <img
                                    src="https://empoweryouth.com/assets/themes/ey/images/pages/webinar/icons-join.png"/>
                            </div>
                            <div class="step-text">
                                <h3>2. Join</h3>
                                <p>At the time of the webinar, click on the join link sent in the mail. You will be
                                    redirected
                                    to the webinar detail page. Click on the 'Join Now' button and you will be in the
                                    webinar.</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-4">
                        <div class="step">
                            <div class="step-img">
                                <img
                                    src="https://empoweryouth.com/assets/themes/ey/images/pages/webinar/icons-watch.png"/>
                            </div>
                            <div class="step-text">
                                <h3>3. Watch</h3>
                                <p>Once the organiser arrived, the webinar will begin. You can also interact with them
                                    before
                                    the Live Chat. Enjoy your creative learning!</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="opted-web" v-if="optedWebinarsList.length">
            <div class="container">
                <div class="row">
                    <div class="heading-opted">Opted Webinars</div>
                </div>
                <div class="row">
                    <div class="col-md-4 col-sm-6" v-for="wl in optedWebinarsList">
                        <div class="web-card">
                            <div class="web-img">
                                <router-link :to="{path: '/webinar-detail?id=' + wl.webinar_enc_id}">
                                    <img :src="wl.image ? wl.image : '/images/mentorship/default-cover.png'">
                                </router-link>
                                <div class="web-detail-date">
                                    <div class="web-date"
                                         v-html="getDate(wl.webinarEvents[0].start_datetime) +' '+ getMonth(wl.webinarEvents[0].start_datetime)"></div>
                                    <div class="web-paid" v-if="!wl.price || wl.price === '0'">
                                        Free
                                    </div>
                                    <div class="web-paid" v-else>
                                        <i class="fas fa-rupee-sign"></i> {{ wl.price }}
                                    </div>
                                </div>
                            </div>
                            <div class="web-inr">
                                <div class="web-title">
                                    <router-link :to="{path: '/webinar-detail?id=' + wl.webinar_enc_id}">
                                        {{ wl.title }}
                                    </router-link>
                                </div>
                                <div class="web-speaker">
                                    <span>
                                        {{ wl.speakers }}
                                    </span>
                                </div>
                                <div class="web-des" v-html="wl.description"></div>
                            </div>
                            <div class="reg-btn-count">
                                <div class="register-count">
                                    <div class="reg-img" v-if="wl.webinarRegistrations">
                                        <span class="reg" v-for="(av, index) in wl.webinarRegistrations"
                                              v-if="wl.webinarRegistrations.length">
                                            <img :src="av.image"/>
                                        </span>
                                    </div>
                                    <span class="cont"> {{ wl.count }} Registered</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="upcoming-web" v-if="pastWebinarsList.length">
            <div class="container">
                <div class="row">
                    <div class="heading-style">Past Webinars</div>
                </div>
                <div class="row">
                    <div class="col-md-4 col-sm-6" v-for="wl in pastWebinarsList">
                        <div class="web-card">
                            <div class="web-img">
                                <router-link :to="{path: '/webinar-detail?id=' + wl.webinar_enc_id}">
                                    <img :src="wl.image ? wl.image : '/images/mentorship/default-cover.png'">
                                </router-link>
                                <div class="web-detail-date">
                                    <div class="web-date"
                                         v-html="getDate(wl.webinarEvents[0].start_datetime) +' '+ getMonth(wl.webinarEvents[0].start_datetime)"></div>
                                    <div class="web-paid" v-if="!wl.price || wl.price === '0'">
                                        Free
                                    </div>
                                    <div class="web-paid" v-else>
                                        <i class="fas fa-rupee-sign"></i> {{ wl.price }}
                                    </div>
                                </div>
                            </div>
                            <div class="web-inr">
                                <div class="web-title">
                                    <router-link :to="{path: '/webinar-detail?id=' + wl.webinar_enc_id}">
                                        {{ wl.title }}
                                    </router-link>
                                </div>
                                <div class="web-speaker">
                                    <span>
                                        {{ wl.speakers }}
                                    </span>
                                </div>
                                <div class="web-des" v-html="wl.description"></div>
                            </div>
                            <div class="reg-btn-count">
                                <div class="register-count">
                                    <div class="reg-img" v-if="wl.webinarRegistrations">
                                        <span class="reg" v-for="(av, index) in wl.webinarRegistrations"
                                              v-if="wl.webinarRegistrations.length">
                                            <img :src="av.image"/>
                                        </span>
                                    </div>
                                    <span class="cont"> {{ wl.count }} Registered</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="webinar-on-device">
            <div class="container">
                <div class="row">
                    <div class="heading-style">Engage from anywhere on any device</div>
                </div>
                <div class="row steps">
                    <div class="col-sm-4">
                        <div class="icon">
                            <div class="icon-img">
                                <img
                                    src="https://empoweryouth.com/assets/themes/ey/images/pages/webinar/icon-computer.png">
                            </div>
                            On your Desktop
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="icon">
                            <div class="icon-img">
                                <img
                                    src="https://empoweryouth.com/assets/themes/ey/images/pages/webinar/icon-smartphone.png">
                            </div>
                            On your Smartphone
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="icon">
                            <div class="icon-img">
                                <img
                                    src="https://empoweryouth.com/assets/themes/ey/images/pages/webinar/icon-tablet.png">
                            </div>
                            On your Tablet
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="upcoming-web" v-if="data.length">
            <div class="container">
                <div class="row">
                    <div class="heading-style">Webinars Speakers</div>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-md-6" v-for="speaker in data">
                        <div class="ts-speaker">
                            <div class="speaker-img">

                                <img class="img-fluid" :src="speaker.image" v-if="speaker.image">
                                <img class="img-fluid" src="images/user_avatar.png" v-else>

                                <a href="javascript:;" class="view-speaker ts-image-popup"
                                   :data-key="speaker.speaker_enc_id" @click="SpeakerModal($event)">
                                    <i class="fas fa-plus"></i>
                                </a>
                            </div>
                            <div class="ts-speaker-info">
                                <h3 class="ts-title"><a href="#">{{ speaker.fullname }}</a></h3>
                                <p>{{ speaker.designation }}</p>
                            </div>
                        </div>
                    </div>
                    <SpeakerModal></SpeakerModal>
                </div>
            </div>
        </section>
        <section class="req-form">
            <div style="display: flex;flex-wrap: wrap;">
                <div class="col-md-5 col-sm-12 req-web">
                    <div class="req">
                        <h1>Request For A Webinar</h1>
                        <p>- For Enriching Your Organization's Online Content.</p>
                        <p>- Establishing Authority.</p>
                        <p>- Enhanced Branding Value.</p>
                        <p>- Building Trust.</p>
                        <p>- Building Stronger, Lasting Business Relationships.</p>
                        <p>- Accessing The Global Audience.</p>
                        <p>- Sharing Information with the Audience.</p>
                    </div>
                    <div class="req-icon">
                        <img src="https://empoweryouth.com/assets/themes/ey/images/pages/webinar/r-webi.png"/>
                    </div>
                </div>
                <div class="col-md-7 col-sm-12 col-xs-12" style="background-color: #fff;padding: 30px 20px;">
                    <form id="requestWebForm" @submit.prevent="requestWebForm($event)">
                        <div class="row">
                        <div class="col-md-12">
                            <div class="web-form">
                                <label for="topic">Topic</label>
                                <div class="form-group">
                                    <input type="text" id="topic" class="form-control" v-model="topic"/>
                                    <p class="error-msg" v-html="topicError"></p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="web-form">
                                <label for="date">Date</label>
                                <div class="form-group">
                                    <input type="date" id="date" class="form-control" v-model="date"/>
                                    <p class="error-msg" v-html="dateError"></p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="web-form">
                                <label for="seats">Seats</label>
                                <div class="form-group">
                                    <input type="number" id="seats" class="form-control" v-model="seats"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="web-form">
                                <label for="speakers">Speakers</label>
                                <div class="form-group">
                                    <multiselect
                                        v-model="value"
                                        :height="300"
                                        :options="options"
                                        :loading="isLoading"
                                        @search-change="asyncFind"
                                        :multiple="true"
                                        :taggable="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Choose Speakers"
                                        label="full_name"
                                        track-by="full_name"
                                    >
                                        <span slot="noOptions">Enter any keyword to search</span>
                                        <span slot="noResult">No speakers found. Enter Another Keyword to search</span>
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 mt10">
                            <div class="web-form">
                                <label for="objective">Objectives</label><br>
                                <div class="form-group">
                                    <textarea id="objective" v-model="objective" rows="6"cols="20"></textarea>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 text-center">
                            <button type="submit" class="sub-btn gnt-btn">Submit Request</button>
                        </div>
                    </div>
                    </form>
                </div>
            </div>
        </section>

        <!--        <div class="container">-->
        <!--            <div class="row" v-if="webinarsList.length">-->
        <!--                <div class="col-md-12">-->
        <!--                    <div class="col-md-6" v-for="wl in webinarsList">-->
        <!--                        <div class="webinar-box">-->
        <!--                            <div class="tag" v-if="!wl.price || wl.price === '0'">-->
        <!--                                Free-->
        <!--                            </div>-->
        <!--                            <div class="tag" v-else>-->
        <!--                              <i class="fas fa-rupee-sign"></i> {{wl.price}}-->
        <!--                            </div>-->
        <!--                            <div class="webinar-icon">-->
        <!--                                <img :src="wl.image ? wl.image : '/images/mentorship/default-cover.png'">-->
        <!--                            </div>-->
        <!--                            <div class="web-date">-->
        <!--                                <span class="cont" v-html="getDate(wl.webinarEvents[0].start_datetime)"></span>-->
        <!--                                <span class="abs" v-html="getMonth(wl.webinarEvents[0].start_datetime)"></span>-->
        <!--                            </div>-->
        <!--                            <div class="webinar-details">-->
        <!--                                <div class="webinar-title">{{wl.title}}</div>-->
        <!--                                <div class="webinar-city"><i class="far fa-clock"></i> <span-->
        <!--                                        v-html="getTime(wl.webinarEvents[0].start_datetime)"> </span></div>-->
        <!--                                <div class="webinar-desc" v-html="wl.description">-->
        <!--                                </div>-->
        <!--                            </div>-->
        <!--                            <div class="avatars" v-if="wl.webinarRegistrations">-->
        <!--                                  <span class="avatar" v-for="(av, index) in wl.webinarRegistrations.slice(0,6)" v-if="wl.webinarRegistrations.length">-->
        <!--                                      <img :src="av.image">-->
        <!--                                  </span>-->
        <!--                                  <p><span v-html="wl.count"></span> People Registered</p>-->
        <!--                            </div>-->
        <!--                            <div class="new-btns">-->
        <!--                                <div class="join-btn naam" v-if="userType === 'Individual'">-->
        <!--                                    <button type="button" v-on:click="registerWebinar($event)"-->
        <!--                                            :data-key="wl.webinar_enc_id" v-if="!wl.is_registered">Register-->
        <!--                                    </button>-->
        <!--                                    <button type="button" class="disabled" v-else>Registered</button>-->
        <!--                                </div>-->
        <!--                                <div class="detail-btn naam">-->
        <!--                                    <router-link :to="{path: '/webinar-detail?id=' + wl.webinar_enc_id}">-->
        <!--                                        View Details-->
        <!--                                    </router-link>-->
        <!--                                </div>-->
        <!--                                &lt;!&ndash;                                        <div class="sharing-btn naam">&ndash;&gt;-->
        <!--                                &lt;!&ndash;                                            <button type="button" title="share with friend"><i class="fas fa-share"></i>&ndash;&gt;-->
        <!--                                &lt;!&ndash;                                            </button>&ndash;&gt;-->
        <!--                                &lt;!&ndash;                                        </div>&ndash;&gt;-->
        <!--                            </div>-->
        <!--                        </div>-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--            <div class="row" v-else>-->
        <!--                <div class="col-md-12 text-center">-->
        <!--                    <img src="images/dashboard/no_data_found.png" class="no-data-found"/>-->
        <!--                    <h2 class="no-data-found">No Webinars Found</h2>-->
        <!--                    <div id="loading-list">-->
        <!--                        <div class="loading-list"></div>-->
        <!--                        <div class="loading-list-ring"></div>-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--        </div>-->
    </div>
</template>

<script>
import axios from 'axios'
import toastr from "../../../public/js/toastr";
import {paymentAccessToken} from "../../_helpers/apiRoute.js";
import {hideLoader, requestHeaders, showLoader} from "../../_helpers/apiHelper";
import SpeakerModal from "@/components/SpeakerModal";
import Vue from "vue";
import Multiselect from "vue-multiselect";

Vue.component('multiselect', Multiselect)
export default {
    components: {
        Multiselect,
        SpeakerModal
    },
    data: function () {
        return {
            value: [],
            options: [],
            isLoading: false,
            topic: "",
            date: "",
            seats: "",
            objective: "",
            dateError:"",
            topicError:"",
            data: [],
            speaker_data: [],
            webinarsList: [],
            pastWebinarsList: [],
            optedWebinarsList: [],
            userType: this.$store.getters.getUserType,
        }
    },
    mounted() {
        this.getWebinars();
        this.getDetail();
    },
    methods: {
        asyncFind(query) {
            this.isLoading = true
            var t = this;
            var url = this.$store.getters.getDomain;
            axios.get(`${url}api/v2/utilities/webinar-speakers?keyword=${query}`).then(function (response) {
                console.log(response['data']);
                t.options = response['data']['response']['speakers'];
                t.isLoading = false;
            });
        },
        requestWebForm(){
            var t = this;
            t.topicError = t.dateError = '';
            if(!t.topic){
                t.topicError = "Topic can't be blank!";
                return false;
            }
            if(!t.date){
                t.dateError = "Date can't be blank!";
                return false;
            }
            let data = {
                title:t.topic,
                date:t.date,
                seats:t.seats,
                objectives:t.objective,
                speakers:t.value
            }
            var url = this.$store.getters.getDomain;
            axios.post(`${url}api/v2/webinars/request`, data, {headers: requestHeaders()}).then(function (response) {
                if (response['data']['response']['status'] == 200) {
                    t.topic = t.date = t.seats = t.objective = '';
                    t.value = [];
                    toastr.success('Request successfully submitted','Success');
                } else {
                    toastr.success('An error occurred try again later.','Error');
                }
            });
        },
        getWebinars() {
            var t = this;
            var url = this.$store.getters.getDomain;
            // if (t.$store.getters.getUserType == 'Individual') {
            //     axios.post(`${url}api/v2/candhome/get-webinar`, "", {headers: requestHeaders()}).then(function (response) {
                axios.post(`${url}api/v2/webinars/all`, "", {headers: requestHeaders()}).then(function (response) {
                    t.webinarsList = [];
                    if (response['data']['response']['status'] == 200) {
                        t.webinarsList = response['data']['response']['webinars']['upcoming'];
                        t.pastWebinarsList = response['data']['response']['webinars']['past'];
                        t.optedWebinarsList = response['data']['response']['webinars']['opted'];
                    }
                });
            // } else {
            //     axios.post(`${url}api/v2/webinars/list`, "", {headers: requestHeaders()}).then(function (response) {
            //         t.webinarsList = [];
            //         if (response['data']['response']['status'] == 200) {
            //             t.webinarsList = response['data']['response']['data'];
            //         }
            //     });
            // }
        },
        registerWebinar(e) {
            var element = e.currentTarget;
            element.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';
            var data_key = element.getAttribute('data-key');
            var t = this;
            var url = this.$store.getters.getDomain;
            axios.post(`${url}api/v2/webinars/join-webinar`, {webinar_id: data_key}, {headers: requestHeaders()}).then(function (response) {
                if (response['data']['response']['status'] == 201) {
                    element.textContent = 'Registered';
                    element.disabled = true;
                    element.classList = "ra-btn disabled";
                } else if (response['data']['response']['status'] == 200) {
                    t.paymentPage(response['data']['response']['callback'].payment_token, response['data']['response']['callback'].payment_enc_id, response['data']['response']['callback'].registration_enc_id)
                }
            });
        },
        paymentPage(paymentId, paymentEncId, registrationEncId) {
            var t = this;
            var options = {
                "key": paymentAccessToken(), // Enter the Key ID generated from the Dashboard
                "name": "My E-Campus",
                "description": "Webinar Registration Fees",
                "image": "https://www.myecampus.in/images/e_campus_logo.png",
                "modal": {
                    "ondismiss": function () {
                        t.updateApplication('', '', paymentEncId, registrationEncId, 'cancelled');
                    }
                },
                "order_id": paymentId,
                "handler": function (response) {
                    t.updateApplication(response.razorpay_payment_id, response.razorpay_signature, paymentEncId, registrationEncId, 'captured');
                },
            };
            var rzp1 = new Razorpay(options);
            rzp1.open();
            rzp1.on('payment.failed', function (response) {
                t.updateApplication('', '', paymentEncId, registrationEncId, 'failed');
            });
            // Layer.checkout({
            //       token: paymentId,
            //       accesskey: paymentAccessToken(),
            //     },
            //     function (response) {
            //       t.updateApplication(response, paymentEncId, registrationEncId);
            //       if (response.status == "captured") {
            //         // response.payment_token_id
            //         // response.payment_id
            //       } else if (response.status == "created") {
            //       } else if (response.status == "pending") {
            //       } else if (response.status == "failed") {
            //
            //       } else if (response.status == "cancelled") {
            //       }
            //     },
            //     function (err) {
            //       console.log(err)
            //     }
            // );
        },
        // updateApplication(res, paymentEncId, registrationEncId) {
        updateApplication(paymentId, paymentSignature, paymentEncId, registrationEncId, status) {
            var t = this;
            showLoader();
            var url = this.$store.getters.getDomain;
            var res = {};
            // res['loan_app_id'] = loanAppId;
            // res['loan_payment_id'] = eduLoanId;
            res['payment_id'] = paymentId;
            res['signature'] = paymentSignature;
            res['payment_status'] = status;
            res['payment_enc_id'] = paymentEncId;
            res['registration_enc_id'] = registrationEncId;
            axios.post(`${url}api/v2/webinars/update-status`, res, {
                headers: requestHeaders()
            }).then(function (response) {
                if (response['data']['response']['status'] == 200) {
                    toastr.success('Webinar Fees ' + res.payment_status, 'Success');
                    location.reload();
                    // t.$router.push({path: '/dashboard'});
                } else {
                    // t.getFeeComponents();
                }
                hideLoader();
            })
                .catch(function (error) {
                    // t.getFeeComponents();
                })
        },
        SpeakerModal(event) {
            var element = event.currentTarget;
            var data_key = element.getAttribute('data-key');
            var t = this;
            var url = this.$store.getters.getDomain;
            axios.post(`${url}api/v2/webinars/speaker-detail`, {speaker_enc_id: data_key}, {headers: requestHeaders()}).then(function (response) {
                if (response['data']['response']['status'] == 200) {
                    t.speaker_data = response['data']['response']['data'];
                    // console.log(t.speakerData);
                    $('#speaker').modal('show');
                    t.$children[0].getSpeakerData();
                }
            });
        },
        getDetail() {
            var t = this;
            var url = this.$store.getters.getDomain;
            axios.post(`${url}api/v2/webinars/speakers`, '', {headers: requestHeaders()}).then(function (response) {
                if (response['data']['response']['status'] == 200) {
                    t.data = response['data']['response']['data'];
                }
            });
        },
        speakerData() {
            return this.speaker_data;
        },
        getDate(e) {
            var d = new Date(e);
            return d.getDate();
        },
        getMonth(e) {
            var d = new Date(e);
            var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            return months[d.getMonth()];
        },
        getTime(e) {
            var d = new Date(e);
            return d.getHours() + ' : ' + d.getMinutes();
        },
    }
}
</script>

<style scoped>
.flex-set {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.header-txt {
    padding-left: 35px;
}

.header-web {
    background-color: #E8F6EF;
    position: relative;
    overflow: hidden;
    min-height: 500px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.back-shadow {
    position: absolute;
    top: -22%;
    right: 0;
    width: 50%;
    background-color: #00a0e3;
    height: 144%;
    border-radius: 50% 0 0 50%;
}

.header-txt h1 {
    font-size: 44px;
    font-family: roboto;
    font-weight: 700;
    margin-top: 0px;
    color: #00a0e3;
    margin-bottom: 0;
    letter-spacing: 1.5px;
    text-transform: uppercase;
}

.header-txt h2 {
    font-size: 20px;
    font-family: roboto;
    margin: 0 0 0 8px;
    color: #707070;
    font-weight: 500;
    text-transform: capitalize;
}

.header-img {
    width: 350px;
    margin: auto;
}

.header-img img {
    width: 100%;
}

.ornge {
    color: #00a0e3;
    font-weight: 500;
}

.web-card:hover {
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.3);
    transform: translateY(-3px);
    transition: all .2s;
}

.web-card {
    border-radius: 6px;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
    background-color: #fff;
    margin-bottom: 20px;
    min-height: 395px;
}

.web-img {
    position: relative;
}

.web-img img {
    height: 200px;
    object-fit: cover;
    width: 100%;
}

.web-detail-date {
    position: absolute;
    bottom: 5px;
    right: 10px;
    display: flex;
    align-items: center;
}

.web-date {
    border-radius: 4px;
    padding: 2px 8px;
    text-align: center;
    border: 2px solid #00a0e3;
    font-weight: 500;
    font-family: roboto;
    background-color: #00a0e3;
    color: #fff;
    margin-right: 2px;
}

.web-paid {
    background-color: #ff7803;
    border: 2px solid #ff7803;
    border-radius: 4px;
    padding: 2px 8px;
    text-align: center;
    text-transform: uppercase;
    font-family: roboto;
    font-weight: 500;
    color: #fff;
}

.web-inr {
    padding: 5px 10px 10px;
}

.web-title {
    font-size: 22px;
    font-family: lora;
    font-weight: 600;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.web-title a {
    color: #333
}

.web-title a:hover {
    color: #00a0e3;
}

.web-speaker {
    font-size: 12px;
    font-family: roboto;
    color: #a49f9f;
    font-weight: 500;
    padding: 5px 0px;
}

.web-des {
    font-family: roboto;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    height: 70px;
    line-height: 1.7;
}

.how-it-works {
    background: #fcfcfc;
    margin-bottom: 20px;
    padding-bottom: 20px;
}

.reg-btn-count {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 10px 10px;
}

.register-count {
    font-family: roboto;
    color: #f97364;
    font-weight: 500;
    display: flex;
    align-items: center;
}

.reg img {
    width: 35px;
    border-radius: 81px;
    height: 30px;
    object-fit: cover;
    border: 2px solid #fff;
}

.reg:nth-child(2), .reg:nth-child(3) {
    margin-left: -25px;
}

.register-btns:hover .btn-drib {
    color: #fff;
}

.btn-drib:hover .icon-drib {
    animation: bounce 1s infinite;
    color: #fff;
}

.btn-drib {
    border: 1px solid transparent;
    color: #fff;
    text-align: center;
    font-size: 14px;
    border-radius: 5px;
    cursor: pointer;
    padding: 6px 10px;
    background-color: #00a0e3;
    font-family: roboto;
    font-weight: 500;
}

.icon-drib {
    margin-right: 5px;
}

.field-speakers span {
    display: block !important;
}

.upcoming-web {
    margin-top: 40px;
}

.how-it-works .step {
    text-align: center;
    background-color: #fff;
    padding: 20px;
    transition: 0.3s ease-in;
}

.how-it-works {
    margin-bottom: 20px;
}

.how-it-works .step-text h3 {
    font-size: 20px;
    font-family: lora;
    font-weight: 600;
    color: #000;
    letter-spacing: 0.3px;
    margin: 20px 0;
}

.how-it-works .step-text p {
    font-size: 16px;
    font-family: roboto;
    color: #717171;
    letter-spacing: 0.3px;
    line-height: 24px;
}

.how-it-works .step:hover {
    box-shadow: 0 2px 12px rgb(0 0 0 / 20%);
}

.step-img img {
    width: 60px;
}

.icon-img {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
    background: #204E8445;
    margin-bottom: 10px;
}

.icon-img img {
    width: 30px;
}

.icon {
    color: #494949;
    font-weight: 600;
    width: fit-content;
    margin: auto;
    font-size: 18px;
}

.steps {
    margin: 50px 0;
}

.step {
    min-height: 300px;
    margin-bottom: 10px;
}

.icon {
    margin-bottom: 40px;
}
.web-form{
    margin: 0px 0px 0px 2px;
}
.web-form label{
    font-size: 18px;
    font-family: roboto;
    font-weight: 400;
    color: #333;
    margin-bottom: 6px;
}
.web-form input,
.web-form textarea{
    border: 1px solid #d4caca;
    padding: 6px;
    border-radius: 4px;
    width: 100%;
    height:40px;
    line-height:22px !important;
    margin-bottom: 10px;
    box-shadow:none;
}
.web-form textarea{
    margin-bottom: 10px;
    height: 100px;
}
.web-button{
    text-align:center;
}
.web-button button{
    font-family: roboto;
    font-size: 16px;
    padding: 12px 21px;
    border-radius: 4px;
    border:none;
    background-color: #fff;
    color: #000;
    transition:all .3s;
    box-shadow: 2px 4px 17px rgba(221, 216, 216, 0.8);
    margin-top: 20px;
    border: 1px solid #d4caca;
}
.web-button button:hover{
    box-shadow: 2px 4px 17px rgba(221, 216, 216, 0.8);
    background-color: #00a0e3;
    color: #fff;
}
.req-web{
    display: flex;
    background-color: #3e8cf9;
    flex-direction: column;
    justify-content: space-between;
}
.req h1{
    font-size: 36px;
    text-align: center;
    font-family: lobster;
    padding: 20px  0 10px;
    color: #fff;
}
.req p{
    font-size: 16px;
    color: #fff;
    text-align: center;
    font-family: roboto;
    font-weight: 400;
    margin:0 0 5px 0;
}
.req-icon {
    max-width: 350px;
    margin: 0 auto;
}
.req-icon img{
    width: 100%;
}
.sub-btn {
    background: #00a0e3;
    color: #fff;
    padding: 10px 15px;
    border: 1px solid #00a0e3;
    font-size: 14px;
    text-transform: uppercase;
    transition: all .3s;
    font-family:roboto;
    font-weight: 500;
    border-radius: 4px;
}
.sub-btn:hover{
    background: #fff;
    color: #00a0e3;
}
.opted-web {
    background-image: url("https://empoweryouth.com/assets/themes/ey/images/pages/webinar/wb2.png");
    margin: 0px 0 0;
    padding: 30px 0 50px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
}
.heading-opted {
    text-align: center;
    font-family: Montserrat;
    font-size: 40px;
    color: #3b1d82;
    margin-bottom: 35px;
    position: relative;
}

</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>